var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import { useId } from "react";
import { GLYPHS } from "./glyphs";
// IconOven's own slash. Iconify's "-off" icons are drawn without it, so it is added here.
var SLASH = "m3.75 3.75l16.5 16.5";
// Glyphs are drawn for 24px at 1.5 (dots at 2); at chip size they read too thin, so every stroke is drawn 1.5× heavier.
var WEIGHT = 1.5;
var LINE = 1.5 * WEIGHT;
var weighted = function (body) {
    return body.replace(/stroke-width="([\d.]+)"/g, function (_, width) { return "stroke-width=\"".concat(Number(width) * WEIGHT, "\""); });
};
export function ValueIcon(_a) {
    var glyph = _a.glyph, _b = _a.off, off = _b === void 0 ? false : _b, props = __rest(_a, ["glyph", "off"]);
    // useId gives ":r1:"; colons are unsafe inside url(#…).
    var maskId = "value-icon-".concat(useId().replace(/:/g, ""));
    var body = _jsx("g", { dangerouslySetInnerHTML: { __html: weighted(GLYPHS[glyph]) } });
    return (_jsx(SvgIcon, __assign({ viewBox: "0 0 24 24" }, props, { children: off ? (_jsxs(_Fragment, { children: [_jsxs("mask", __assign({ id: maskId, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, { children: [_jsx("rect", { width: 24, height: 24, fill: "#fff" }), _jsx("path", { d: SLASH, stroke: "#000", strokeWidth: LINE * 3, strokeLinecap: "round" })] })), _jsx("g", __assign({ mask: "url(#".concat(maskId, ")") }, { children: body })), _jsx("path", { d: SLASH, fill: "none", stroke: "currentColor", strokeWidth: LINE, strokeLinecap: "round" })] })) : body })));
}
